export function withAnchor(url: string, anchor: string): string {
  const [base, ...rest] = url.split("#");
  let hashRoute = rest.join("#");
  const anchorIndex = hashRoute.lastIndexOf("#");

  if (anchorIndex !== -1) {
    hashRoute = hashRoute.substring(0, anchorIndex);
  }

  return `${base}#${hashRoute}#${anchor}`;
}

export const blendWithWhite = (hexWithOpacity: string): string => {
  // Ожидаемый формат: #RRGGBBAA
  if (!/^#([0-9a-fA-F]{6})([0-9a-fA-F]{2})$/.test(hexWithOpacity)) {
    return hexWithOpacity;
    // throw new Error("Неверный формат цвета. Ожидается #RRGGBBAA.");
  }

  // Извлекаем RGB и альфа-канал
  const hex = hexWithOpacity.slice(1, 7); // первые 6 символов (RRGGBB)
  const alphaHex = hexWithOpacity.slice(7, 9); // последние 2 символа (AA)

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const alpha = parseInt(alphaHex, 16) / 255; // альфа в диапазоне 0–1

  // Смешиваем каждый канал с белым (255)
  const blendedR = Math.round((1 - alpha) * 255 + alpha * r);
  const blendedG = Math.round((1 - alpha) * 255 + alpha * g);
  const blendedB = Math.round((1 - alpha) * 255 + alpha * b);

  // Переводим результат обратно в hex
  const blendedHex =
    "#" +
    blendedR.toString(16).padStart(2, "0") +
    blendedG.toString(16).padStart(2, "0") +
    blendedB.toString(16).padStart(2, "0");

  return blendedHex;
};
